import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Simple implementation that returns zero spaces until products decide to
 * implement their own or use mhub's.
 */
export class LocalUserNavigationService {
  constructor() {
    _defineProperty(this, "_spaces", void 0);
    this._spaces = [];
  }
  async getUserNavigation() {
    return {
      spaces: this._spaces,
      navBarSpaceItems: {
        mainItems: this._spaces.map(space => space.identifyingName),
        otherItems: []
      }
    };
  }
}
//# sourceMappingURL=LocalUserNavigationService.js.map
